import {PLANET_HD_EARLIEST_CAMPAIGN_YEAR} from '../Images/planetHdAcquisitionQuery'

export const PLANET_HD_AMBIENT_MODES = {
  AUTOMATIC: 'automatic',
  CUSTOM: 'custom',
}

export const buildPlanetHdHistoricalAmbientPayload = ({
  countAmbients = 5,
  mode,
  monthRange = ['10', '05'],
  yearsList = [],
}) => {
  if (mode !== PLANET_HD_AMBIENT_MODES.CUSTOM) {
    return {mode: PLANET_HD_AMBIENT_MODES.AUTOMATIC}
  }

  return {
    mode: PLANET_HD_AMBIENT_MODES.CUSTOM,
    month_range: monthRange,
    years_list: yearsList.filter(
      (year) => Number(year) >= PLANET_HD_EARLIEST_CAMPAIGN_YEAR
    ),
    count_ambients: countAmbients,
  }
}
